import { IonChip, IonLabel, IonText } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setPartOfFilterVisible } from "../../../store/locations";
import { selectPartOfFilter } from "../../../store/locations/selectors/selectPartOfFilter";

export const FilterPartOfChip: React.FC = () => {
  const locations = useSelector(selectPartOfFilter);
  const dispatch = useDispatch();

  return (
    <IonChip
      onClick={() => dispatch(setPartOfFilterVisible(true))}
      outline
      color={locations?.length ? "primary" : "medium"}
    >
      <IonLabel class="ion-text-nowrap">
        {locations?.length ? (
          <IonText color="primary" style={{ fontWeight: 600 }}>
            <span>Area de negocio: </span>
            {locations?.map(
              (locationItem, index) =>
                locationItem.name + (locations?.length === index + 1 ? "" : ", ")
            )}
          </IonText>
        ) : (
          <span>Area de negocio: Todos</span>
        )}
      </IonLabel>
    </IonChip>
  );
};
